import { useContext, useMemo } from 'react';

import type { GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import {
  GridStatusBar,
  type GridStatusBarParams,
  WithLocalStorage,
} from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';
import { PrimaryContext } from '@/services';
import type { ShipmentDonor } from '@/services/shipping/types';
import { useContextMenu } from '@/utils/context-menu';

import { donorColumnDefs } from '../../utils/columnDefs';

type ShipmentDonorGridProps = {
  donors: ShipmentDonor[] | null | undefined;
};

export const ShipmentDonorGrid = ({ donors }: ShipmentDonorGridProps) => {
  const defaultGridOptions = useDefaultGridOptions();
  const { themeMode } = useContext(PrimaryContext);
  const { getContextMenuItems } = useContextMenu({ idKey: 'id' });

  const statusBar = useMemo<NonNullable<GridOptions['statusBar']>>(
    () => ({
      statusPanels: [
        {
          statusPanel: GridStatusBar,
          statusPanelParams: {
            entityLabel: 'donors',
          } satisfies GridStatusBarParams,
          align: 'left',
        },
      ],
    }),
    [],
  );

  return (
    <div className="shipment__grid ag-grid-height-300">
      <WithLocalStorage storageKey="shipment-donor-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`}
          defaultColDef={defaultColDef}
          rowData={donors}
          columnDefs={donorColumnDefs}
          getContextMenuItems={getContextMenuItems}
          rowSelection="multiple"
          statusBar={statusBar}
        />
      </WithLocalStorage>
    </div>
  );
};
